import { getConfig } from '@cian/config/browser';
import { getHttpApi } from '@cian/http-api/browser';
import { getLogger } from '@cian/logger/browser';

import { IApplicationContext, IApplicationContextCustom } from 'shared/context/applicationContext/types';

export const createContext = (): IApplicationContext => {
  const config = getConfig();

  return {
    config,
    custom: config.getStrict<IApplicationContextCustom>('applicationContext.custom'),
    httpApi: getHttpApi(),
    logger: getLogger(),
  };
};
